import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

const Tip = ({ text }) => (
  <Tooltip title={text} placement="bottomRight">
    <span className="appkiticon icon-information-fill dd-tip-icon" />
  </Tooltip>
);
function ProjectFormLabel(props) {
  const {
    text,
    tip,
    className = '',
    wrapperClassName = '',
    subText = '',
    onClick,
  } = props;

  const tipComp = tip ? <Tip text={tip} /> : null;

  const handleClick = (e) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <div className={`project-form-label ${wrapperClassName}`}>
      <span
        onClick={handleClick}
        style={{ position: 'relative' }}
        className={`dd-label-text ${className}`}
      >
        {text} {subText}
      </span>

      {tipComp}
    </div>
  );
}

ProjectFormLabel.defaultProps = {
  text: '',
  tip: '',
};

ProjectFormLabel.propTypes = {
  text: PropTypes.string,
  tip: PropTypes.string,
};

export default ProjectFormLabel;
